//  默认头像
export const defaultAvatar = 'https://www.carryglobal.vip/other/static/images/minePhoto.png'
